import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginPage} from '../pages/login/login';
import {AccountPage} from '../pages/account/account';
import {TransactionPage} from '../pages/transaction/transaction';
import {TransactionAddPage} from '../pages/transaction-form/transaction-form-add';
import {TransactionEditPage} from '../pages/transaction-form/transaction-form-edit';
import {CategoryPage} from '../pages/category/category';
import {PeriodicTransactionPage} from '../pages/periodic-transaction/periodic-transaction';
import {PeriodicTransactionLogPage} from '../pages/periodic-transaction-log/periodic-transaction-log';
import {ReportPage} from '../pages/report/report';
import {PeriodicTransactionAddPage} from '../pages/periodic-transaction-form/periodic-transaction-form-add'
import {PeriodicTransactionEditPage} from '../pages/periodic-transaction-form/periodic-transaction-form-edit'

import {ReportMonthlyPage} from '../pages/report-monthly/report-monthly';
import {ReportDetailedPage} from '../pages/report-detailed/report-detailed';

import { ServerProvider } from '../providers/server/server';
import { LocalStorageServiceProvider } from '../providers/local-storage-service/local-storage-service';
import { PeriodicityFormatterProvider } from '../providers/periodicity-formatter/periodicity-formatter';
import { AuthenticationServiceProvider } from '../providers/authentication-service/authentication-service';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    AccountPage,
    TransactionPage,
    TransactionAddPage,
    TransactionEditPage,
    CategoryPage,
    PeriodicTransactionPage,
    PeriodicTransactionLogPage,
    ReportPage,
    PeriodicTransactionAddPage,
    PeriodicTransactionEditPage,
    ReportMonthlyPage,
    ReportDetailedPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    AccountPage,
    TransactionPage,
    TransactionAddPage,
    TransactionEditPage,
    CategoryPage,
    PeriodicTransactionPage,
    PeriodicTransactionLogPage,
    ReportPage,
    PeriodicTransactionAddPage,
    PeriodicTransactionEditPage,
    ReportMonthlyPage,
    ReportDetailedPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ServerProvider,
    LocalStorageServiceProvider,
    PeriodicityFormatterProvider,
    AuthenticationServiceProvider,
    CategoryPage,
    PeriodicTransactionPage,
    ReportPage
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts